import { render } from "./Logo.vue?vue&type=template&id=83fc29a2&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=83fc29a2&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fc29a2"]])

export default __exports__